import React, { useContext, useEffect, useRef, useState } from "react";
import SearchIcon from "../assets/images/search-lg-icon.svg";
import filterLines from "../assets/images/filter-lines.svg";
import downloadIcon from "../assets/images/download-icon.svg";
import trashIcon from "../assets/images/trash-icon.svg";
import plusIcon from "../assets/images/plus-icon.svg";
import threeDots from "../assets/images/dots-vertical.svg";
import close from "../assets/images/x-close.svg";
import { Space, Table } from "antd";
import _ from "lodash";
import { Modal } from "react-bootstrap";
import searchicon from "../assets/images/search-lg-icon.svg";

import {
  PostCallWithErrorResponse,
  simpleGetCall,
  simpleGetCallWithErrorResponse,
} from "../Api/ApiServices";
import { ApiConfig, USER_WEB_URL } from "../Api/ApiConfig";
import NoDataFound from "../component/noDataFound";

import {
  div,
  Button,
  Form,
  option,
  FormControl,
  FormGroup,
  Badge,
} from "react-bootstrap";
import { toastMsg } from "../component/toast";
import { render } from "@testing-library/react";
import AppState from "../context/AppState";
import { AppContext } from "../context/AppContext";
import { hover } from "@testing-library/user-event/dist/hover";
import Select from "react-select";
import AddCompany from "./AddCompany";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { update } from "./Slices/tableSlice";

const GroupList = (props) => {
  // const [hide, setHide] = useState(false);

  const { codeRespondendHandler, clearCode } = props;

  const [valiteded, setValiteded] = useState(false);

  const [checkStrictly, setCheckStrictly] = useState(false);

  const [isActive, setIsActive] = useState(true);
  const [isActivewin, setIsActivewin] = useState(false);
  const [isAddCompany, setIsAddCompany] = useState(false);
  const [companies, setCompanies] = useState([]);

  const profilePer = {
    codeId: 0,
    id: 0,
    pioneer: "",
    influencer: "",
    teamPlayer: "",
    logicalThinker: "",
    persuader: "",
    achiever: "",
    perfectionist: "",
    collaborator: "",
    assessor: "",
    implementor: "",
    motivator: "",
    leader: "",
    administrator: "",
    mediator: "",
    allRounder: "",
  };

  const initialState = {
    id: 0,
    accessCode: "",
    reason: "",
    company: "",
    companyId: "",
    designation: "",
    additionalQs1: "no",
    additionalQs2: "no",
    questionOne: "",
    questionTwo: "",
    questionThree: "",
    address: "",
    linktoAssess: "",
    idealExp: [],
    eduLevel: [],
    eduArea: [],
    industry: [],
    salaryRange: "",
    startDate: "",
    primaryMatch: "",
    secoundryMatch: "",
    primaryProfile: "",
    secoundryProfile: "",
    association: "",
    isActive: true,
    from: "",
    isNormalAssesment: true,
    aboutJob: "",
    aboutCompany: "",
  };

  const [details, setDetails] = useState(initialState);

  const { adminData, setCompnayDtls } = useContext(AppContext);

  const [initialProfiles, setInitialProfiles] = useState(profilePer);

  const [isEdit, setIsEdit] = useState(false);

  const [show, setShow] = useState(false);
  const [reqfield, setReqfield] = useState(null);
  const handleClose = () => {
    setShowModal(false);
    setDetails(initialState);

    setEnterEmail("");

    setShowEmails([]);

    setIsEdit(false);

    setValiteded(false);

    setInitialProfiles(profilePer);

    setShow(false);
  };
  const handleShow = () => setShow(true);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      console.log("File selected:", file.name);
      // You can add further logic to handle the file upload here
    }
  };

  const [groupListData, setGroupListData] = useState([]);

  const navigate = useNavigate();

  const [isLoadin, setIsLoading] = useState(true);

  const [rowsToShow, setRowsToShow] = useState(10);

  const handleRowsToShowChange = (event) => {
    setRowsToShow(Number(event.target.value));
  };

  const getData = () => {
    const url = `${ApiConfig.GROUP_LIST}${JSON.parse(
      localStorage.getItem("email")
    )}&IsActive=${isActive}`;
    simpleGetCallWithErrorResponse(url)
      .then((res) => {
        console.log(res);

        if (res?.json?.succeded) {
          setGroupListData(res?.json?.response);
          console.log(res?.json?.data?.length);
        } else {
          console.log("something went wrong");
        }

        setIsLoading(false);
      })
      .catch((err) => {
        console.log("something went wrong");

        setIsLoading(false);
      });
  };

  useEffect(() => {
    //codeRespondendHandler('')
    clearCode();
    getData();
    getCompanies();
  }, [isActive]);

  const getCompanies = () => {
    simpleGetCall(ApiConfig.GET_COMPANY_LIST).then((res) => {
      if (res?.succeded) {
        let companiesList = res?.response?.map((i) => ({
          value: i?.id,
          label: i?.companyName,
        }));

        companiesList[0] = {
          value: "",
          label: "Add Company Name",
        };

        setCompanies(companiesList);
      } else {
        setCompanies([]);
      }
    });
  };

  const copyCode = (code) => {
    navigator.clipboard.writeText(
      // "https://lywouserweb.app.cloudxperte.com/?code=" + code
      // "http://localhost:3000/?code=" + code
      USER_WEB_URL + "?code=" + code + '&step=1'
      // 'https://apply.lywo.in/?code=' + code
    );
  };

  const [error, setError] = useState("");
  const [errorAdd, setErrorAdd] = useState("");

  const handleSubmit = (event) => {
    alert('')
    event.preventDefault();
    event.stopPropagation();

    const form = event.currentTarget;
    if (!form.checkValidity()) {
      console.log(form.checkValidity());
      setValiteded(true);
      return;
    }

    if (!details) {
      console.error("Details are not defined");
      return;
    }

    const urlRegex = /^(https?:\/\/[^\s$.?#].[^\s]*)$/;
    const googleDocsRegex = /https?:\/\/docs\.google\.com\//;

    // const customQuestion1 = details.additionalQs1.trim();
    // if (customQuestion1 && customQuestion1 !== "YES" && customQuestion1 !== "NO") {
    //   toastMsg("error", "Custom Question 1 must be 'YES' or 'NO' if entered");
    //   return;
    // }

    // const customQuestion2 = details.additionalQs2.trim();
    // if (customQuestion2 && customQuestion2 !== "YES" && customQuestion2 !== "NO") {
    //   toastMsg("error", "Custom Question 2 must be 'YES' or 'NO' if entered");
    //   return;
    // }

    // const customQuestion3 = details.additionalQs3.trim();
    // if (customQuestion3 && customQuestion3 !== "YES" && customQuestion3 !== "NO") {
    //   toastMsg("error", "Custom Question 3 must be 'YES' or 'NO' if entered");
    //   return;
    // }

    if (details.address && !googleDocsRegex.test(details.address)) {
      toastMsg(
        "error",
        "Please enter a valid Google Document link for 'Address of the Sheet"
      );
      return;
    }

    if (details.linktoAssess && !urlRegex.test(details.linktoAssess)) {
      toastMsg(
        "error",
        "Please enter a valid hyperlink for 'Link to Assessment'"
      );
      return;
    }

    if (details.accessCode.length !== 7) {
      toastMsg("error", "Please enter a 7-digit valid access code");
      return;
    }

    if (showEmails.length === 0 && details.reason === "Job Application") {
      alert('')
      toastMsg("error", "Please add users");
      return;
    }

    if (!details?.companyId) {
      toastMsg("error", "Please Select Company Name");
      return;
    }
    const payload = {
      id: details.id,
      isActive: details.isActive,
      code: details.accessCode,
      codeAssociation: details.association,
      position: details.designation,
      reason: details.reason,
      company: details.company,
      companyId: details?.companyId,
      additionalPart1: details.additionalQs1,
      additionalPart2: details.additionalQs2,
      primaryId: details.primaryProfile,
      secondaryId: details.secoundryProfile,
      primaryMatch: details.primaryMatch,
      secondaryMatch: details.secoundryMatch,
      profilePer: details.reason === "Job Application" ? initialProfiles : {},
      users: showEmails,
      question1: details.questionOne,
      question2: details.questionTwo,
      question3: details.questionThree,
      addressOfSheet: details.address,
      fromEmail: details.from,
      linkToAssessment: details.linktoAssess,
      idealExperience: details.idealExp,
      idealEducationLevel: details.eduLevel,
      idealEducationArea: details.eduArea,
      idealIndustry: details.industry,
      idealSalaryRange: details.salaryRange,
      idealStartDate: details.startDate,
      isNormalAssesment: details.isNormalAssesment,
    };

    PostCallWithErrorResponse(ApiConfig?.ADD_JOB, payload)
      .then((res) => {
        if (res?.json?.succeded) {
          setIsEdit(false);
          toastMsg("success", res?.json?.response?.statusMessage);
          getData();
          handleClose();
        } else {
          toastMsg("error", res?.json?.response?.statusMessage);
        }
      })
      .catch((err) => {
        console.error("Something went wrong:", err);
      });
  };

  const paginationConfig = {
    pageSizeOptions: [
      "10",
      "20",
      "30",
      "40",
      "50",
      "60",
      "70",
      "80",
      "90",
      "100",
    ], // Options for items per page
    defaultPageSize: 500000, // Default number of items per page
    showSizeChanger: false, // Show the dropdown to change page size
    onChange: (page, pageSize) => {
      console.log("Page:", page, "PageSize:", pageSize);
    },
  };

  const handleChage = (key, val) => {
    if (key === "reason") {
      let prt1 = "";
      let part2 = "";

      if (
        val === "Individual User" ||
        val === "Investor" ||
        val === "Investor as Individual User"
      ) {
        prt1 = "no";
        part2 = "no";
      }

      if (val === "Job Application") {
        prt1 = "yes";
        part2 = "no";
      }

      if (val === "Internal Assessment") {
        prt1 = "no";
        part2 = "yes";
      }

      setDetails((prev) => ({
        ...prev,
        reason: val,
        additionalQs1: prt1,
        additionalQs2: part2,
      }));
      const urlPattern = /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w-./?%&=]*)?$/;
      if (!urlPattern.test(details.linktoAssess)) {
        setError("Please enter a valid hyperlink (e.g., https://example.com)");
      } else {
        setError("");
      }

      return;
    }

    setDetails((prev) => ({
      ...prev,
      [key]: val,
    }));
  };
  // const [enterEmail, setEnterEmail] = useState("");
  // const [showEmails, setShowEmails] = useState([]);
  // const [showed, setShowed] = useState(false);

  // const handleAddEmail = () => {
  //   setShowEmails([...showEmails, enterEmail]);
  //   setShowed(true);
  //   setEnterEmail("");
  // };
  const [enterEmail, setEnterEmail] = useState("");
  const [showEmails, setShowEmails] = useState([]);
  const [showed, setShowed] = useState(false);

  const handleAddEmail = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (enterEmail.trim() !== "") {
      if (!emailRegex.test(enterEmail)) {
        toastMsg("error", "Please Enter Valid User Email");
        return;
      }

      let index = showEmails.findIndex((i) => i.email === enterEmail);

      if (index != -1) {
        toastMsg("error", "Email Already Added");
        return;
      }

      setShowEmails([
        ...showEmails,
        {
          codeId: 0,
          email: enterEmail,
        },
      ]);
      setShow(true);
      setEnterEmail("");
    }
  };

  const removeEmail = (indexToRemove) => {
    const updatedEmails = showEmails.filter(
      (_, index) => index !== indexToRemove
    );
    setShowEmails(updatedEmails);
  };

  const deleteJobCode = (id) => {
    PostCallWithErrorResponse(ApiConfig.DELETE_JOB_CODE + id).then((res) => {
      if (res?.json?.succeded) {
        getData();
        toastMsg("success", res?.json?.response?.statusMessage);
      } else {
        toastMsg("error", res?.json?.response?.statusMessage);
      }
    });
  };

  const handleProfiles = (key, val) => {
    setInitialProfiles((prev) => ({
      ...prev,
      [key]: val,
    }));
  };

  const filterData = (data) => (formatter) =>
    data.map((item) => ({
      text: formatter(item),
      value: formatter(item),
    }));
  // const [filteredInfo, setFilteredInfo] = useState({});

  const filteredInfo = useSelector((state) => state.tableState.codeFilters);
  const dispatch = useDispatch();
  const [sortedInfo, setSortedInfo] = useState({});

  const handleChange = (pagination, filters, sorter) => {
    console.log("Various parameters", pagination, filters, sorter);

    dispatch(update({ key: "codeFilters", value: filters }));
    dispatch(update({ key: "codeSorter", value: sorter }));
    setSortedInfo(sorter);
  };

  const handleActiveDeActiveCode = (status, code) => {
    PostCallWithErrorResponse(ApiConfig.ACTIVEDEACTIVECODE, {
      code: code,
      active: !status,
    }).then((res) => {
      res = res?.json;

      if (res.succeded) {
        toastMsg("success", res?.response?.statusMessage);
        getData();
      } else {
        toastMsg("error", res?.response?.statusMessage);
      }
    });
  };

  const columns = [
    {
      title: "Access Code",
      render: (record) => <h5 className="my-auto">{record}</h5>,
      dataIndex: "code",
      sorter: (a, b) => a.code.localeCompare(b.code),
      filters: _.uniqWith(
        filterData(groupListData)((i) => i.code),
        _.isEqual
      ),
      filteredValue: filteredInfo.code || null,
      filterSearch: true,
      onFilter: (value, record) =>
        record.code.toString().toLowerCase().includes(value.toLowerCase()),
      onCell: (record, rowIndex) => {
        return {
          onClick: (env) => {

            navigate('/candidateList/' + record?.code)

            setCompnayDtls({
              company: record?.designation,
              designation: record?.designation,
              position: record?.reason
            });
            // codeRespondendHandler(
            //   record?.code,
            //   record?.company,
            //   record?.designation,
            //   record?.reason
            // );
          },
        };
      },
    },

    {
      title: "Form Type",
      dataIndex: "reason",
      sorter: (a, b) => a.reason?.localeCompare(b.reason),
      filters: _.uniqWith(
        filterData(groupListData)((i) => i.reason),
        _.isEqual
      ),
      filteredValue: filteredInfo.reason || null,
      filterSearch: true,
      onFilter: (value, record) =>
        record.reason.toString().toLowerCase().includes(value.toLowerCase()),
    },
    {
      title: "Company",
      dataIndex: "company",
      sorter: (a, b) => a.company?.localeCompare(b.company),
      filters: _.uniqWith(
        filterData(groupListData)((i) => i.company),
        _.isEqual
      ),
      filteredValue: filteredInfo.company || null,
      filterSearch: true,
      onFilter: (value, record) =>
        value === ""
          ? record.company.toString().toLowerCase() === value.toLowerCase()
          : record.company
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()),
    },
    {
      title: "Designation",
      dataIndex: "designation",
      sorter: (a, b) => a.designation.localeCompare(b.designation),
      filters: _.uniqWith(
        filterData(groupListData)((i) => i.designation),
        _.isEqual
      ),
      filteredValue: filteredInfo.designation || null,
      filterSearch: true,
      onFilter: (value, record) =>
        value === ""
          ? record.designation.toString().toLowerCase() === value.toLowerCase()
          : record.designation
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()),
    },
    // {
    //   title: "Add'l Qs Part 1",
    //   dataIndex: "additionalPart1",
    //   sorter: (a, b) => a.additionalpart1 - b.additionalpart1,
    //   filters: _.uniqWith(
    //     filterData(groupListData)((i) => i.additionalPart1),
    //     _.isEqual
    //   ),
    //   filteredValue: filteredInfo.additionalPart1 || null,
    //   filterSearch: true,
    //   onFilter: (value, record) =>
    //     record.additionalPart1 ? record.additionalPart1.includes(value) : false,
    // },
    // {
    //   title: "Add'l Qs Part 2",
    //   dataIndex: "additionalPart2",
    //   sorter: (a, b) =>
    //     new Date(a.additionalpart2) - new Date(b.additionalPart2),
    //   filters: _.uniqWith(
    //     filterData(groupListData)((i) => i.additionalPart2),
    //     _.isEqual
    //   ),
    //   filteredValue: filteredInfo.additionalPart2 || null,
    //   filterSearch: true,
    //   onFilter: (value, record) =>
    //     record.additionalPart2 ? record.additionalPart2.includes(value) : false,
    // },
    // {
    //   title: "Applications",
    //   dataIndex: "completed",
    //   sorter: (a, b) => new Date(a.completed) - new Date(b.completed),
    //   filters: _.uniqWith(
    //     filterData(groupListData)((i) => i.completed),
    //     _.isEqual
    //   ),
    //   filteredValue: filteredInfo.completed  ,
    //   filterSearch: true,
    //   onFilter: (value, record) => record?.completed == value,
    // },
    {
      title: "Applications",
      dataIndex: ["completed", "respondent"],
      sorter: (a, b) => new Date(a.completed) - new Date(b.completed),

      // filters: _.uniqWith(
      //   filterData(groupListData)((i) => i.completed),
      //   _.isEqual
      // ).map((item) => ({ text: item, value: item })),
      filteredValue: filteredInfo?.completed,
      // filterSearch: false,
      // onFilter: (value, record) => {
      //   return record?.completed === value;
      // },
      render: (text, record) => {
        return `${record.completed} / ${record.respondent}`;
      },
    },
    {
      title: "Actions",
      render: (record) => (
        <div class="dropdown">
          <img
            src={threeDots}
            alt=""
            type="button"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          />
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <li
              class="dropdown-item"
              style={{ cursor: "pointer", fontSize: '14px' }}
              onClick={() => copyCode(record?.code)}

            >
              Copy Link
            </li>
            <li
              class="dropdown-item"
              style={{ cursor: "pointer", fontSize: "14px" }}
              onClick={() => {

                setCompnayDtls({
                  company: record?.designation,
                  designation: record?.designation,
                  position: record?.reason
                });
                navigate('/candidateList/' + record?.code)
                // codeRespondendHandler(
                //   record?.code,
                //   record?.company,
                //   record?.designation,
                //   record?.reason
                // )
              }
              }
            >
              View Respondents
            </li>
            {/* {localStorage.getItem("admin") &&
              JSON.parse(localStorage.getItem("admin")) == "Admin" && ( */}
            {
              (record?.permission?.isView || record?.permission?.isEdit) &&
              <li
                class="dropdown-item"
                style={{ cursor: "pointer", fontSize: '14px' }}
                onClick={() =>
                  navigate(`/addEditGroup/${record?.code}/?isAccessCode=true`)
                }
              >
                Edit
              </li>
            }
            {/* )} */}
            <li
              class="dropdown-item"
              style={{ cursor: "pointer", fontSize: '14px' }}
              onClick={() =>
                handleActiveDeActiveCode(record?.isActive, record?.code)
              }
            >
              {record?.isActive ? "InActive" : "Active"}
            </li>
            {!record?.isActive && (
              <li
                class="dropdown-item"
                style={{ cursor: "pointer", fontSize: '14px' }}
                onClick={() => deleteJobCode(record?.code)}
              >
                Delete
              </li>
            )}
          </div>
        </div >
      ),
    },
  ];
  const [checked, setChecked] = useState(true);
  const handleClickcheck = () => {
    setChecked(!checked);
  };

  const toggleSwitch = () => {
    setIsActive(!isActive);
  };
  const toggleSwitchWindow = () => {
    setIsActivewin(!isActivewin);
  };

  const getEditData = (code) => {
    navigate(`/addEditGroup/${code}?isAccessCode=true`);
    setIsEdit(true);

    // simpleGetCallWithErrorResponse(ApiConfig.GET_CODE_DETAILS + code).then(
    //   (res) => {
    //     console.log(res);

    //     if (res?.json?.succeded) {
    //       const responseData = res?.json?.response;
    //       setSelectedIndustry(
    //         transformIndustryToOptions(responseData?.idealIndustry)
    //       );
    //       setSelectedOptions(
    //         transformEduLevelToOptions(responseData?.idealEducationLevel)
    //       );
    //       setSelectedArea(
    //         transformEduAreaToOptions(responseData?.idealEducationArea)
    //       );
    //       setSelectedSalary(
    //         transformSalaryToOptions(responseData?.idealSalaryRange)
    //       );
    //       setSelectedExp(transformExpToOptions(responseData?.idealExperience));

    //       // Set ideal experience
    //       setIdealExp(responseData?.idealExperience || []);
    //       setInputValue("");

    //       setDetails({
    //         industry: responseData?.idealIndustry,
    //       });
    //       setDetails({
    //         isActive: res?.json?.response?.isActive,
    //         id: res?.json?.response?.id,
    //         accessCode: code,
    //         reason: res?.json?.response?.reason,
    //         company: res?.json?.response?.company,
    //         companyId: res?.json?.response?.companyId,
    //         designation: res?.json?.response?.position,
    //         additionalQs1: res?.json?.response?.additionalPart1,
    //         additionalQs2: res?.json?.response?.primaryMatch,
    //         primaryMatch: res?.json?.response?.primaryMatch,
    //         secoundryMatch: res?.json?.response?.secondaryMatch,
    //         primaryProfile: res?.json?.response?.primaryId,
    //         secoundryProfile: res?.json?.response?.secondaryId,
    //         association: res?.json?.response?.codeAssociation,

    //         questionOne: res?.json?.response?.question1,
    //         questionTwo: res?.json?.response?.question2,
    //         questionThree: res?.json?.response?.question3,
    //         isNormalAssesment: res?.json?.response?.isNormalAssesment,
    //         address: res?.json?.response?.addressOfSheet,
    //         linktoAssess: res?.json?.response?.linkToAssessment,
    //         from: res?.json?.response?.fromEmail,
    //         idealExp: res?.json?.response?.idealExperience,
    //         eduLevel: res?.json?.response?.idealEducationLevel,
    //         eduArea: res?.json?.response?.idealEducationArea,
    //         industry: res?.json?.response?.idealIndustry,
    //         salaryRange: res?.json?.response?.idealSalaryRange,
    //         startDate:
    //           res?.json?.response?.reason === "Job Application"
    //             ? res?.json?.response?.idealStartDate
    //               ? res?.json?.response?.idealStartDate
    //                 .split("T")[0]
    //                 .split("-")
    //                 .join("-")
    //               : null
    //             : null,
    //       });
    //       handleShowAddGrp();
    //       // handleShow();

    //       if (res?.json?.response?.reason === "Job Application") {
    //         setShowEmails(res?.json?.response?.users);

    //         if (res?.json?.response?.profilePer) {
    //           setInitialProfiles(res?.json?.response?.profilePer);
    //         }
    //       }
    //     } else {
    //       toastMsg("error", res?.json?.message);
    //     }
    //   }
    // );
  };

  const [showAddGrp, setShowAddGrp] = useState(null);
  const [showModal, setShowModal] = useState(null);

  const handleShowAddGrp = () => {
    // setHide(true);
    setShowModal(true);
    handleShow();
    // setShowAddGrp(true);
  };

  const [areaList, setAreaList] = useState([]);

  useEffect(() => {
    getAllspecialization();
    getAllIndustryList();
    getEmailList();
  }, []);

  const [industryList, setIndustryList] = useState([]);
  const getAllIndustryList = () => {
    simpleGetCall(ApiConfig.GET_INDUSTRY_LIST)
      .then((res) => {
        if (res.succeded) {
          setIndustryList(res?.response);
        } else {
          setIndustryList([]);
        }
      })
      .catch((err) => console.log(err));
  };
  const getAllspecialization = () => {
    simpleGetCall(ApiConfig.GET_AREA_OF_EDUCATION)
      .then((res) => {
        if (res.succeded) {
          setAreaList(res.response);
          console.log(res.response);
        } else {
          setAreaList([]);
        }
      })
      .catch((err) => console.log(err));
  };

  // const [filteredGrpListData, setFilteredGrpListData] = useState([]);
  // const [filterVal, setFilterVal] = useState("");
  // const handleFilterVal = (e) => {
  //   const { value } = e.target;
  //   setFilterVal(value);
  //   setFilteredGrpListData(groupListData.filter(x => x.company.toLowerCase().includes(value) || x.designation.toLowerCase().includes(value)));
  // }

  const [emailList, setEmailList] = useState([]);
  const getEmailList = () => {
    simpleGetCallWithErrorResponse(ApiConfig.GET_AUTHENTICATED_SENDERS)
      .then((res) => {
        console.log(res.json);

        setEmailList(res.json);
      })
      .catch((err) => console.log(err));
  };

  const expOptions = [
    { value: "1-3", label: "1 to 3 Yrs" },
    { value: "3-5", label: "3 to 5 Yrs" },
    { value: "5-7", label: "5 to 7 Yrs" },
    { value: "7-9", label: "7 to 9 Yrs" },
    { value: "9-12", label: "9 to 12 Yrs" },
    { value: "12-15", label: "12 to 15 Yrs" },
    { value: "15-20", label: "15 to 20 Yrs" },
    { value: "20-25", label: "20 to 25 Yrs" },
    { value: "25-30", label: "25 to 30 Yrs" },
    { value: "30+", label: "Above 30 Yrs" },
  ];
  const [selectedExp, setSelectedExp] = useState([]);
  const handleExpChange = (selected) => {
    setSelectedExp(selected || []);
    setDetails({ ...details, idealExp: selected ? [selected.value] : [] });
    console.log(details);
  };

  const options = [
    { value: "High School", label: "High School" },
    { value: "Diploma", label: "Diploma" },
    { value: "PG Diploma", label: "PG Diploma" },
    { value: "Bachelor's", label: "Bachelor's" },
    { value: "Master's", label: "Master's" },
    { value: "PhD", label: "PhD" },
  ];

  const [selectedOptions, setSelectedOptions] = useState([]);
  const handleChangemulti = (selected) => {
    setSelectedOptions(selected || []);

    const selectedValues = (selected || []).map((option) => option.value);
    setDetails({ ...details, eduLevel: selectedValues });
    console.log(details);
  };

  const [selectedArea, setSelectedArea] = useState([]);
  const optionsArealist = areaList.map((x) => ({
    value: x.specializationName,
    label: x.specializationName,
  }));
  const handleMultiArea = (selected) => {
    setSelectedArea(selected || []);
    const selectedValues = (selected || []).map((option) => option.value);
    setDetails({ ...details, eduArea: selectedValues });
    console.log(details);
  };
  const [selectedIndustry, setSelectedIndustry] = useState([]);
  const optionsIndustry = industryList.map((x) => ({
    value: x.label,
    label: x.label,
  }));
  const transformIndustryToOptions = (industries) => {
    if (!industries) return [];
    return industries.map((industry) => ({
      value: industry,
      label: industry,
    }));
  };

  const transformEduLevelToOptions = (eduLevels) => {
    if (!eduLevels) return [];
    return eduLevels.map((level) => ({
      value: level,
      label: level,
    }));
  };

  const transformEduAreaToOptions = (eduAreas) => {
    if (!eduAreas) return [];
    return eduAreas.map((area) => ({
      value: area,
      label: area,
    }));
  };

  const transformSalaryToOptions = (salaryRanges) => {
    if (!salaryRanges) return [];
    return salaryRanges.map((range) => ({
      value: range,
      label: range,
    }));
  };
  const transformExpToOptions = (experiences) => {
    if (!experiences) return [];
    return experiences.map((exp) => ({
      value: exp,
      label: exp.replace("-", " to ") + " Yrs",
    }));
  };

  const handleMultiIndustry = (selected) => {
    setSelectedIndustry(selected || []);
    const selectedValues = (selected || []).map((option) => option.value);
    setDetails({ ...details, industry: selectedValues });
    console.log(details);
  };

  const [selectedSalary, setSelectedSalary] = useState([]);
  const optionsSalary = [
    { value: "Below 3 Lakhs per year  ", label: "Below 3 Lakhs per year" },
    { value: "3-6 Lakhs per year", label: "3-6 Lakhs per year" },
    { value: "6-10 Lakhs per year", label: "6-10 Lakhs per year" },
    { value: "10-15 Lakhs per year", label: "10-15 Lakhs per year" },
    { value: "15-20 Lakhs per year", label: "15-20 Lakhs per year" },
    { value: "20-25 Lakhs per year", label: "20-25 Lakhs per year" },
    { value: "25-30 Lakhs per year", label: "25-30 Lakhs per year" },
    { value: "Above 30 Lakhs per year", label: "Above 30 Lakhs per year" },
    { value: "Above 50 Lakhs per year", label: "Above 50 Lakhs per year" },
    { value: "Above 1 Crore per year", label: "Above 1 Crore per year" },
  ];
  const handleMultiSalary = (selected) => {
    setSelectedSalary(selected || []);
    const selectedValues = (selected || []).map((option) => option.value);
    setDetails({ ...details, salaryRange: selectedValues });
    console.log(details);
  };

  const [inputValue, setInputValue] = useState("");
  const [idealExpp, setIdealExp] = useState([]);

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      const exp = inputValue.trim();
      if (exp > 0 && !idealExpp.includes(exp)) {
        const newExp = [...idealExpp, exp];
        setIdealExp(newExp);
        setDetails((prev) => ({ ...prev, idealExp: newExp }));
      }
      setInputValue("");
    }

    if (e.key === "Backspace" && inputValue.length === 0) {
      const newExp = idealExpp.slice(0, -1);
      setIdealExp(newExp);
      setDetails((prev) => ({ ...prev, idealExp: newExp }));
    }
  };
  const removeExp = (exp) => {
    setIdealExp(idealExpp.filter((x) => x !== exp));
    setDetails({ ...details, idealExp: idealExpp });
    console.log(details);
  };

  const handleAddCompamy = () => {
    getCompanies();

    setIsAddCompany(false);
  };

  return (
    <>
      {!showModal && (
        <>
          {" "}
          <div className="row justify-content-between mt-4">
            <div className="col-2 my-auto">
              {/* <div className="canLisIconBox p-0 d-flex">
                <input
                  type="text"
                  className="bg-white border-0 search-input pe-2 rounded-2"
                />
              </div> */}
            </div>

            <div className="col-10 d-flex justify-content-end ">
              {/* <div className="col-3 my-auto">
                <input
                  value={filterVal}
                  onChange={handleFilterVal}
                  type="text"
                  style={{height:"35px"}}
                  className="bg-white border search-input pe-2 rounded-2"
                />
              </div> */}
              <div className="col-3 my-auto ml-4">
                <div className="row align-items-center">
                  <div
                    className="col-4 text-nowrap toggle-label text-end"
                    style={{ fontSize: "12px" }}
                  >
                    Inactive Only
                  </div>
                  <div
                    style={{ scale: "0.8" }}
                    onClick={toggleSwitch}
                    className={`col-2 toggle-switch ${isActive ? "active" : ""
                      }`}
                  >
                    <div className="toggle-circle"></div>
                  </div>
                  <div
                    className="col-1 text-nowrap toggle-label"
                    style={{ marginLeft: "-12px", fontSize: "12px" }}
                  >
                    Active Only
                  </div>
                </div>
              </div>

              <div className="col-2 d-flex justify-content-end">
                {localStorage.getItem("admin") &&
                  JSON.parse(localStorage.getItem("admin")) === "Admin" && (
                    <button
                      style={{ fontSize: "12px" }}
                      className="ml-4 btnVldt"
                      onClick={() => navigate("/addEditGroup/new")}
                    >
                      Create Assesment Link
                    </button>
                  )}
              </div> 
              <div className="col-2 d-flex justify-content-end">
                {localStorage.getItem("admin") &&
                  JSON.parse(localStorage.getItem("admin")) === "Admin" && (
                    <button
                      style={{ fontSize: "12px" }}
                      className="ml-4 btnVldt"
                      onClick={() => navigate("/AssessmentNew")}
                    >
                      Create Assesment New Page
                    </button>
                  )}
              </div>
            </div>
          </div>
          <div className="candListBox ">
            <div className="candListHdr">
              <div className="canLisTxtStyl">
                <p>Group List</p>
              </div>

              <div className="grouplist-table">
                <Table
                  size="large"
                  columns={columns}
                  className="grouplisttable-alljobs"
                  // dataSource={filteredGrpListData.length>0? filteredGrpListData : groupListData}
                  dataSource={groupListData}
                  onChange={handleChange}
                  pagination={paginationConfig}
                ></Table>
              </div>

              {/* <div className="canLisSearchArea">
          <div className="searchBox">
            <img src={SearchIcon} className="boxIcon" alt="Logo" />
            <Form.Control
              type="text"
              className="searchForm.Control"
              placeholder="Search"
              // readOnly
            />
          </div>
          <div className="canLisIconBox">
            <img src={filterLines} className="boxIcon" alt="Logo" />
          </div>
          <div className="canLisIconBox">
            <img src={downloadIcon} className="boxIcon" alt="Logo" />
          </div>
          <div className="canLisIconBox">
            <img src={trashIcon} className="boxIcon" alt="Logo" />
          </div>
          {/* <button className="uploadBtn" onClick={handleUploadClick}>
            <img src={plusIcon} className="boxIcon" alt="Logo" />
            <p>Upload</p>
            <Form.Control
              type="file"
              className="fileForm.Control"
              ref={fileForm.ControlRef}
              onChange={handleFileChange}
              style={{ display: "none" }}
              accept=".pdf,.doc,.docx"
            />
          </button> }
        </div> */}
            </div>
          </div>{" "}
        </>
      )}

      {showModal && (
        <div
          // show={show}
          // centered
          // onHide={handleClose}
          dialogClassName="custom-modal"
          // size={`${details.reason === "Job Application" ? "xl" : "lg"}`}
          className="t-wrapper-div"
        >
          <div>
            <div closeButton className="custom-close-btn">
              <div className="d-flex justify-content-between">
                <h5 className="custom-modal-title">Add/ Edit Group</h5>
                <button className="btn-close" onClick={handleClose}></button>
              </div>
              <hr />
            </div>
            <div>
              <Form noValidate validated={valiteded} onSubmit={handleSubmit}>
                <div className="mb-3 mt-2">
                  <div>
                    <h5 className="fw-bold">About Job</h5>
                    <Form.Control
                      as="textarea"
                      rows={4} // number of visible lines
                      placeholder="Enter About Job"
                      style={{
                        border:
                          details?.aboutJob?.length > 0
                            ? "0px solid black"
                            : "2px solid grey",
                      }}
                    />
                  </div>
                  <div className="mt-3">
                    <h5 className="fw-bold">About Company</h5>
                    <Form.Control
                      as="textarea"
                      rows={4} // number of visible lines
                      placeholder="Enter About Job"
                      style={{
                        border:
                          details?.aboutCompany?.length > 0
                            ? "0px solid black"
                            : null,
                      }}
                    />
                  </div>
                </div>
                <div className="row">
                  <div
                    className={`${details.reason === "Job Application" ? "col-9" : "col-12"
                      }`}
                  >
                    <h5 className="headinfClr">Job Details</h5>
                    <div className="d-flex align-items-center mt-3">
                      <div className="col-12">
                        <Form.Group
                          controlId="accessCode"
                          className="mb-3"
                          style={{ display: "flex" }}
                        >
                          <Form.Label className="job_size col-md-2">
                            Access Code
                          </Form.Label>
                          <div
                            className="col-md-8"
                            style={{
                              flex: 1,
                            }}
                          >
                            <Form.Control
                              style={{ fontSize: "14px", width: "90%" }}
                              disabled={isEdit}
                              type="text"
                              placeholder="Access Code"
                              id="accessCode"
                              value={details.accessCode}
                              className="input-text-14 col-md-9"
                              minLength={7}
                              maxLength={7}
                              required
                              isInvalid={
                                valiteded && details.accessCode.length != 7
                              }
                              onChange={(e) =>
                                handleChage(
                                  "accessCode",
                                  e.target.value.toUpperCase()
                                )
                              }
                            />
                            <Form.Control.Feedback type="invalid">
                              Please Enter 7 Digit Valid Code!
                            </Form.Control.Feedback>
                          </div>
                        </Form.Group>
                      </div>

                      {/* <div className="col-3 ms-5 d-flex mt-3">
                    <Form.Check
                      type="checkbox"
                      onClick={handleClickcheck}
                    ></Form.Check>
                    {checked ? (
                      <Form.Label className="ms-3">Deactive</Form.Label>
                    ) : (
                      <Form.Label className="ms-3">Active</Form.Label>
                    )}
                  </div> */}
                    </div>
                    <div className=" col-auto   ">
                      <div className="col-md-3"></div>

                      <div className="d-flex gap-2">
                        <span className="job_size col-md-2">Status</span>
                        <div>
                          <label
                            className="radio-label"
                            onClick={() => {
                              handleChage("isActive", false);
                            }}
                          >
                            <input
                              type="radio"
                              id="inActive"
                              name="statusInActive"
                              checked={!details?.isActive}
                              value={!details?.isActive}
                              placeholder="inActive"
                            />
                            <span for="inActive" className="">
                              In Active{" "}
                            </span>
                          </label>
                        </div>
                        <div>
                          <label
                            className="radio-label"
                            onClick={() => {
                              handleChage("isActive", true);
                            }}
                          >
                            <input
                              type="radio"
                              id="Active"
                              name="statusActive"
                              checked={details?.isActive}
                              value={details?.isActive}
                              placeholder="Active"
                            />
                            <span for="inActive" className="ml-3">
                              Active{" "}
                            </span>
                          </label>
                        </div>
                      </div>
                    </div>
                    {/*                 
                <Form.Group controlId="accessCode" className="mb-3">
                  <Form.Label>Access Code</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Access Code"
                    id="accessCode"
                    value={details.accessCode}
                    minLength={7}
                    maxLength={7}
                    required
                    isInvalid={valiteded && details.accessCode.length != 7}
                    onChange={(e) =>
                      handleChage("accessCode", e.target.value.toUpperCase())
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    Please Enter 7 Digit Valid Code!
                  </Form.Control.Feedback>
                </Form.Group> */}
                    <div className="row">
                      <Form.Group
                        controlId="reason"
                        className="mb-3 col-md-12 mt-2"
                        style={{ display: "flex" }}
                      >
                        <Form.Label className="job_size col-md-2">
                          Application Type
                        </Form.Label>
                        <div
                          className="col-md-8"
                          style={{
                            flex: 1,

                            borderRadius: "5px",
                            width: "90%",
                          }}
                        >
                          <Form.Select
                            disabled={isEdit}
                            className="input-text-14"
                            required
                            value={details?.reason}
                            style={{ fontSize: "14px" }}
                            onChange={(e) => {
                              setValiteded(false);
                              handleChage("reason", e.target.value);
                            }}
                          >
                            <option
                              disabled
                              value={""}
                              className="job_size"
                              style={{ fontSize: "14px" }}
                            >
                              Select reason
                            </option>
                            {/* <option value="Individual User">Individual User</option> */}
                            <option
                              value="Job Application"
                              className="job_size"
                              style={{ fontSize: "14px" }}
                            >
                              Job Application
                            </option>
                            <option
                              value="Internal Assessment"
                              className="job_size"
                            >
                              Internal Assessment
                            </option>
                            <option
                              value="Investor As Individual User"
                              className="job_size"
                            >
                              Investor As Individual User
                            </option>
                          </Form.Select>
                          <Form.Control.Feedback
                            type="invalid"
                            className="job_size"
                          >
                            Please Select Reason!
                          </Form.Control.Feedback>
                        </div>
                        <div className="col-md-1"></div>
                      </Form.Group>
                    </div>
                    {details?.reason !== "Individual User" &&
                      details?.reason !== "Investor" &&
                      details?.reason !== "" && (
                        <>
                          <div
                            className="mb-3 col-md-12 mt-2"
                            style={{ display: "flex" }}
                          >
                            <label
                              className="form-label job_size col-md-2 mt-3"
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              Company Name
                            </label>
                            <div className="col-md-9 mt-2">
                              <Select
                                isMulti={false}
                                options={companies}
                                value={
                                  companies.find(
                                    (option) =>
                                      option.value === details?.companyId
                                  ) || null
                                }
                                onChange={(e) => {
                                  setDetails((prev) => ({
                                    ...prev,
                                    company: e.label,
                                    companyId: e.value,
                                  }));
                                }}
                                classNamePrefix="select"
                                placeholder="Company Name"
                                className="input-text-14"
                              />
                            </div>
                            {/* {selectedOptions.length === 0 && (
        <div className="invalid-feedback d-block">
          Please select at least one Ideal Education Level
        </div>
      
      )} */}
                            <div
                              className="col-md-1 "
                              style={{ marginLeft: "10px" }}
                            >
                              <button
                                className="btnVldt"
                                style={{ fontSize: "12px", marginTop: "4px" }}
                                type="button"
                                onClick={() => setIsAddCompany(true)}
                              >
                                {details?.companyId ? "Edit" : "Add"}
                              </button>
                            </div>
                          </div>
                        </>
                      )}
                    {details.reason === "Job Application" && (
                      <Form.Group
                        controlId="designation"
                        className="mb-3"
                        style={{ display: "flex" }}
                      >
                        <Form.Label className="job_size  col-md-2">
                          Designation
                        </Form.Label>
                        <div
                          className="col-md-8"
                          style={{
                            flex: 1,
                          }}
                        >
                          <Form.Control
                            type="text"
                            className="input-text-14 col-md-9"
                            required
                            placeholder="Designation"
                            style={{ width: "90%" }}
                            value={details?.designation}
                            onChange={(e) =>
                              handleChage("designation", e.target.value)
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Designation!
                          </Form.Control.Feedback>
                        </div>
                      </Form.Group>
                    )}

                    {details?.reason !== "Individual User" &&
                      details?.reason !== "Investor" &&
                      details?.reason !== "" && (
                        <div className="row">
                          {/* <Form.Group controlId="designation" className="mb-3">
                        <Form.Label>Designation</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Designation"
                          required
                          value={details?.designation}
                          onChange={(e) =>
                            handleChage("designation", e.target.value)
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          Please Enter Designation!
                        </Form.Control.Feedback>
                      </Form.Group> */}

                          {/* 
                  <Form.Group controlId="primary profile" className="mb-3">
                    <Form.Label>Primary Profile </Form.Label>
                    <Form.Select
                      required
                      value={details?.primaryProfile}
                      onChange={(e) =>
                        handleChage("primaryProfile", e.target.value)
                      }
                    >
                      <option disabled value={""}>
                        Select Primary Profile
                      </option>
                      <option value="1">Pioneer</option>
                      <option value="2">Influencer </option>
                      <option value="3">Team Player</option>
                      <option value="4">Logical Thinker</option>

                      <option value="5">Persuader</option>
                      <option value="7">perfectionist</option>
                      <option value="8">Collaborater</option>
                      <option value="9">Accessor</option>
                      <option value="10">Implementor</option>
                      <option value="11">Motivator</option>
                      <option value="12">Leader</option>
                      <option value="13">Administrator</option>
                      <option value="14">Mediator</option>
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      Please Select Prmary Profile!
                    </Form.Control.Feedback>
                   
                  </Form.Group>

                  <Form.Group controlId="secoundry profile" className="mb-3">
                    <Form.Label>Secoundry Profile </Form.Label>
                    <Form.Select
                      required
                      value={details?.secoundryProfile}
                      onChange={(e) =>
                        handleChage("secoundryProfile", e.target.value)
                      }
                    >
                      <option disabled value={""}>
                        Select Secoundry Profile
                      </option>
                      <option value="1">Pioneer</option>
                      <option value="2">Influencer </option>
                      <option value="3">Team Player</option>
                      <option value="4">Logical Thinker</option>

                      <option value="5">Persuader</option>
                      <option value="7">perfectionist</option>
                      <option value="8">Collaborater</option>
                      <option value="9">Accessor</option>
                      <option value="10">Implementor</option>
                      <option value="11">Motivator</option>
                      <option value="12">Leader</option>
                      <option value="13">Administrator</option>
                      <option value="14">Mediator</option>
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      Please Select Prmary Profile!
                    </Form.Control.Feedback>
                  
                  </Form.Group> */}
                        </div>
                      )}

                    {/* {details.reason === "Internal Assessment" && (
                  <>
                    <Form.Group controlId="primary profile" className="mb-3">
                      <Form.Label>Primary Profile </Form.Label>
                      <Form.Select
                        required
                        value={details?.primaryProfile}
                        onChange={(e) =>
                          handleChage("primaryProfile", e.target.value)
                        }
                      >
                        <option disabled value={""}>
                          Select Primary Profile
                        </option>
                        <option value="1">Pioneer</option>
                        <option value="2">Influencer </option>
                        <option value="3">Team Player</option>
                        <option value="4">Logical Thinker</option>

                        <option value="5">Persuader</option>
                        <option value="7">perfectionist</option>
                        <option value="8">Collaborater</option>
                        <option value="9">Accessor</option>
                        <option value="10">Implementor</option>
                        <option value="11">Motivator</option>
                        <option value="12">Leader</option>
                        <option value="13">Administrator</option>
                        <option value="14">Mediator</option>
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        Please Select Prmary Profile!
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group controlId="secoundry profile" className="mb-3">
                      <Form.Label>Secoundry Profile </Form.Label>
                      <Form.Select
                        required
                        value={details?.secoundryProfile}
                        onChange={(e) =>
                          handleChage("secoundryProfile", e.target.value)
                        }
                      >
                        <option disabled value={""}>
                          Select Secoundry Profile
                        </option>
                        <option value="1">Pioneer</option>
                        <option value="2">Influencer </option>
                        <option value="3">Team Player</option>
                        <option value="4">Logical Thinker</option>

                        <option value="5">Persuader</option>
                        <option value="7">perfectionist</option>
                        <option value="8">Collaborater</option>
                        <option value="9">Accessor</option>
                        <option value="10">Implementor</option>
                        <option value="11">Motivator</option>
                        <option value="12">Leader</option>
                        <option value="13">Administrator</option>
                        <option value="14">Mediator</option>
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        Please Select Prmary Profile!
                      </Form.Control.Feedback>
                    </Form.Group>
                  </>
                )} */}
                    {details.reason === "Job Application" && (
                      <div className="">
                        <h5 className="headinfClr">ideal Expectations</h5>
                        <Form.Group controlId="idealExp" className="mb-3">
                          <div className="mb-3 " style={{ display: "flex" }}>
                            <Form.Label
                              className="job_size col-md-2"
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              Ideal Experience
                            </Form.Label>
                            <div
                              className="col-md-8"
                              style={{
                                flex: 1,

                                borderRadius: "5px",
                                width: "90%",
                              }}
                            >
                              <Select
                                // isMulti
                                options={expOptions}
                                value={selectedExp}
                                onChange={handleExpChange}
                                classNamePrefix="select"
                                placeholder="Select ideal experience"
                                className="input-text-14"
                                style={{ width: "90%" }}
                              />
                            </div>
                            <div className="col-md-1"></div>
                          </div>
                        </Form.Group>

                        <div className="mb-3" style={{ display: "flex" }}>
                          <label
                            className="form-label job_size col-md-2"
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            Ideal Education Level(s)
                          </label>
                          <div
                            className="col-md-8"
                            style={{
                              flex: 1,

                              borderRadius: "5px",
                              width: "90%",
                            }}
                          >
                            <Select
                              isMulti
                              options={options}
                              value={selectedOptions}
                              onChange={handleChangemulti}
                              classNamePrefix="select"
                              placeholder="Select ideal Education Level"
                              className="input-text-14"
                              style={{ width: "90%" }}
                            />
                          </div>
                          <div className="col-md-1"></div>
                          {/* {selectedOptions.length === 0 && (
        <div className="invalid-feedback d-block">
          Please select at least one Ideal Education Level
        </div>
      )} */}
                        </div>

                        <div className="mb-3" style={{ display: "flex" }}>
                          <label
                            className="form-label job_size col-md-2"
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            Ideal Education Area(s)
                          </label>
                          <div
                            className="col-md-8"
                            style={{
                              flex: 1,

                              borderRadius: "5px",
                              width: "90%",
                            }}
                          >
                            <Select
                              isMulti
                              options={optionsArealist}
                              value={selectedArea}
                              onChange={handleMultiArea}
                              classNamePrefix="select"
                              placeholder="Select ideal Education Area"
                              className="input-text-14"
                            />
                          </div>
                          <div className="col-md-1"></div>
                        </div>

                        <div className="mb-3" style={{ display: "flex" }}>
                          <label
                            className="form-label job_size col-md-2"
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            Ideal Industry(s)
                          </label>
                          <div
                            className="col-md-8"
                            style={{
                              flex: 1,

                              borderRadius: "5px",
                              width: "90%",
                            }}
                          >
                            <Select
                              isMulti
                              options={optionsIndustry}
                              value={selectedIndustry}
                              onChange={handleMultiIndustry}
                              classNamePrefix="select"
                              placeholder="Select ideal Industry"
                              className="input-text-14"
                            />
                          </div>
                          <div className="col-md-1"></div>
                        </div>

                        <div
                          className="mb-3 job_size"
                          style={{ display: "flex" }}
                        >
                          <label
                            className="form-label col-md-2"
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            Ideal Salary Range(s)
                          </label>
                          <div
                            className="col-md-8"
                            style={{
                              flex: 1,

                              borderRadius: "5px",
                              width: "90%",
                            }}
                          >
                            <Select
                              isMulti
                              options={optionsSalary}
                              value={selectedSalary}
                              onChange={handleMultiSalary}
                              classNamePrefix="select"
                              placeholder="Select ideal Salary Range"
                              className="input-text-14"
                            />
                          </div>
                          <div className="col-md-1"></div>
                        </div>

                        <Form.Group
                          controlId="startDate"
                          className="mb-3"
                          style={{ display: "flex" }}
                        >
                          <Form.Label className="job_size col-md-2">
                            Ideal Start Date
                          </Form.Label>
                          <div
                            className="col-md-8"
                            style={{
                              flex: 1,

                              borderRadius: "5px",
                              width: "90%",
                            }}
                          >
                            <Form.Control
                              style={{
                                width: "90%",
                                fontSize: "14px",
                                color: "gray",
                              }}
                              type="date"
                              className="input-text-14"
                              value={details.startDate}
                              onChange={(e) =>
                                handleChage("startDate", e.target.value)
                              }
                              required
                            ></Form.Control>
                            <Form.Control.Feedback type="invalid">
                              Please Select the Ideal Start Date
                            </Form.Control.Feedback>
                          </div>
                        </Form.Group>
                        <h5 className="mt-3 headinfClr">Screening</h5>
                        <div
                          className="col-md-12 mb-2 mt-2"
                          style={{ display: "flex" }}
                        >
                          <label
                            className="job_size col-md-2"
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            Assesment Type
                          </label>
                          <label
                            className="radio-label"
                            onClick={() => {
                              if (isEdit) return;
                              handleChage("isNormalAssesment", false);
                            }}
                          >
                            <input
                              type="radio"
                              id="short"
                              name="shortAss"
                              checked={!details?.isNormalAssesment}
                              value={!details?.isNormalAssesment}
                              placeholder="short"
                            />
                            <span for="short" className="ml-3">
                              Short{" "}
                            </span>
                          </label>
                          <label
                            className="radio-label ml-4"
                            onClick={() => {
                              if (isEdit) return;
                              handleChage("isNormalAssesment", true);
                            }}
                          >
                            <input
                              type="radio"
                              id="normal"
                              name="norass"
                              checked={details?.isNormalAssesment}
                              value={details?.isNormalAssesment}
                              placeholder="normal"
                            />
                            <span for="normal" className="ml-3">
                              Normal{" "}
                            </span>
                          </label>
                        </div>
                        <div
                          className="col-md-12 mb-2 mt-2"
                          style={{ display: "flex" }}
                        >
                          <label
                            className="job_size col-md-2"
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            Quiz Source
                          </label>
                          <label className="radio-label">
                            <input
                              type="radio"
                              id="savedQuiz"
                              name="saved_quiz"
                              Placeholder="short"
                            />
                            <span for="short" className="ml-3">
                              Saved Quiz{" "}
                            </span>
                          </label>
                          <label className="radio-label ml-4">
                            <input
                              type="radio"
                              id="customQuiz"
                              name="custom_Quiz"
                              placeholder="normal"
                            />
                            <span for="normal" className="ml-3">
                              Custom Quiz{" "}
                            </span>
                          </label>

                          <label className="radio-label ml-4">
                            <input
                              type="radio"
                              id="noneQ"
                              name="noneQuiz"
                              placeholder="normal"
                            />
                            <span for="normal" className="ml-3">
                              None{" "}
                            </span>
                          </label>
                        </div>
                        {isEdit ? (
                          <></>
                        ) : (
                          <>
                            <Form.Group
                              className="mb-3"
                              style={{ display: "flex" }}
                            >
                              <Form.Label className="job_size col-md-2">
                                Custom Question 1 (Answer is Yes/No only)
                              </Form.Label>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  width: "90%",
                                }}
                              >
                                <Form.Control
                                  style={{ width: "90%" }}
                                  type="text"
                                  placeholder="Custom Question 1"
                                  value={details.questionOne}
                                  // disabled={isEdit && hide}
                                  className="input-text-14 col-md-9"
                                  onChange={(e) =>
                                    handleChage("questionOne", e.target.value)
                                  }
                                />
                                <Form.Text>
                                  leave blank if you wish to not use
                                </Form.Text>
                              </div>
                            </Form.Group>
                            <Form.Group
                              className="mb-3 job_size "
                              style={{ display: "flex" }}
                            >
                              <Form.Label className="col-md-2">
                                Custom Question 2 (Answer is Yes/No only)
                              </Form.Label>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  width: "90%",
                                }}
                              >
                                <Form.Control
                                  style={{ width: "90%" }}
                                  type="text"
                                  placeholder="Custom Question 2"
                                  value={details.questionTwo}
                                  className="input-text-14 col-md-9"
                                  // disabled={isEdit && hide}
                                  onChange={(e) =>
                                    handleChage("questionTwo", e.target.value)
                                  }
                                />
                                <Form.Text>
                                  leave blank if you wish to not use
                                </Form.Text>
                              </div>
                            </Form.Group>
                            <Form.Group
                              className="mb-3"
                              style={{ display: "flex" }}
                            >
                              <Form.Label className="job_size col-md-2">
                                Custom Question 3 (Answer is Yes/No only)
                              </Form.Label>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  width: "90%",
                                }}
                              >
                                <Form.Control
                                  style={{ width: "90%" }}
                                  type="text"
                                  placeholder="Custom Question 3"
                                  className="input-text-14 col-md-9"
                                  // disabled={isEdit && hide}
                                  value={details.questionThree}
                                  onChange={(e) =>
                                    handleChage("questionThree", e.target.value)
                                  }
                                />
                                <Form.Text>
                                  leave blank if you wish to not use
                                </Form.Text>
                              </div>
                            </Form.Group>
                          </>
                        )}

                        <Form.Group
                          className="mb-3"
                          style={{ display: "flex" }}
                        >
                          <Form.Label className="job_size col-md-2">
                            Address of the Sheet for accessing the Score(Score
                            in Column C, Email in Column B)
                          </Form.Label>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              width: "90%",
                            }}
                          >
                            <Form.Control
                              style={{ width: "90%" }}
                              className="input-text-14 col-md-9"
                              type="text"
                              value={details.address}
                              onChange={(e) =>
                                handleChage("address", e.target.value)
                              }
                            />
                            {!details.address && (
                              <Form.Text>
                                Please enter a valid google document link
                              </Form.Text>
                            )}
                          </div>
                        </Form.Group>

                        <Form.Group
                          className="mb-3 job_size"
                          style={{ display: "flex" }}
                        >
                          <Form.Label
                            className="col-md-2"
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            Link to Assessment
                          </Form.Label>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              width: "90%",
                            }}
                          >
                            <Form.Control
                              style={{ width: "90%" }}
                              className="input-text-14 col-md-9"
                              type="text"
                              value={details.linktoAssess}
                              onChange={(e) =>
                                handleChage("linktoAssess", e.target.value)
                              }
                            // isInvalid={!!error}
                            />
                            <Form.Text type="">
                              {!details.linktoAssess && error}
                            </Form.Text>
                          </div>
                        </Form.Group>
                        <h5 className="mt-3 headinfClr">Access and Control</h5>
                        <Form.Group
                          className="mb-3 mt-3"
                          style={{ display: "flex" }}
                        >
                          <Form.Label className="job_size col-md-2">
                            Email Id to be used to <br />
                            send communications <br /> to candidate
                          </Form.Label>
                          <div
                            className="col-md-8"
                            style={{
                              flex: 1,

                              borderRadius: "5px",
                              width: "90%",
                            }}
                          >
                            <Form.Select
                              className="input-text-14 "
                              style={{ fontSize: "14px", color: "gray" }}
                              value={details.from}
                              onChange={(e) =>
                                handleChage("from", e.target.value)
                              }
                            >
                              <option value="" selected disabled>
                                Select Email
                              </option>
                              {emailList
                                .filter((x) => x.verified === true)
                                .map((email, index) => (
                                  <option value={email.from_Email} key={index}>
                                    {email.from_Email}
                                  </option>
                                ))}
                            </Form.Select>
                          </div>
                          <div className="col-md-1"></div>
                        </Form.Group>
                        <div
                          className="row justify-content-between mt-3"
                          style={{ display: "flex" }}
                        >
                          <Form.Label
                            className="job_size col-md-2"
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            Job Access Group
                          </Form.Label>
                          <div
                            className="col-md-8"
                            style={{
                              flex: 1,

                              borderRadius: "5px",
                              width: "90%",
                            }}
                          >
                            <input
                              className="form-control input-text-14"
                              type="email"
                              isInvalid={valiteded && showEmails.length}
                              placeholder="Job Access Group"
                              value={enterEmail}
                              onChange={(e) => setEnterEmail(e.target.value)}
                            />
                            {/* <Form.Control.Feedback type="invalid">
                              Please Add Company Users!
                            </Form.Control.Feedback> */}
                          </div>
                          <div className="col-md-1">
                            <button
                              className="btnVldt"
                              type="button"
                              style={{ fontSize: "12px" }}
                              onClick={handleAddEmail}
                            >
                              Add
                            </button>
                          </div>
                        </div>
                        <div
                          className="col-5 position-absolute start-0 mt-3"
                          style={{ marginLeft: "270px" }}
                        >
                          {showEmails.map((email, index) => (
                            <span
                              className="addbackgroundcolor px-2 py-1 rounded-5 me-3 text-nowrap"
                              key={index}
                            >
                              {email?.email}
                              <button
                                type="button"
                                className="btn-close"
                                style={{
                                  width: "5px",
                                  height: "7px",
                                  marginLeft: "4px",
                                  opacity: "0.8",
                                  marginBottom: "-5px",
                                }}
                                onClick={() => removeEmail(index)}
                              ></button>
                            </span>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="col-3">
                    {details.reason === "Job Application" && (
                      <>
                        {
                          <>
                            <h5 className="headinfClr">Personalities</h5>
                            <table className="group-table table table-hover mb-5 mt-3">
                              <thead>
                                <tr>
                                  <th>Profile</th>
                                  <th>Match</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td className="job_size">Pioneer (1)</td>
                                  <td className="d-flex justify-content-center align-items-center">
                                    <Form.Control
                                      type="number"
                                      className="input-text-14 me-1"
                                      required
                                      style={{ width: "65px" }}
                                      value={initialProfiles?.pioneer}
                                      onChange={(e) => {
                                        if (
                                          (Number(e.target.value) <= 100 &&
                                            Number(e.target.value >= 0)) ||
                                          e.target.value === ""
                                        ) {
                                          handleProfiles(
                                            "pioneer",
                                            e.target.value
                                          );
                                        }
                                      }}
                                    />
                                    %
                                  </td>
                                </tr>
                                <tr>
                                  <td className="job_size">Influencer (2)</td>
                                  <td className="d-flex justify-content-center align-items-center">
                                    <Form.Control
                                      style={{ width: "65px" }}
                                      className="input-text-14 me-1"
                                      type="number"
                                      required
                                      value={initialProfiles?.influencer}
                                      onChange={(e) => {
                                        if (
                                          (Number(e.target.value) <= 100 &&
                                            Number(e.target.value >= 0)) ||
                                          e.target.value === ""
                                        ) {
                                          handleProfiles(
                                            "influencer",
                                            e.target.value
                                          );
                                        }
                                      }}
                                    ></Form.Control>
                                    %
                                  </td>
                                </tr>
                                <tr>
                                  <td className="job_size">Team Player (3)</td>
                                  <td className="d-flex justify-content-center align-items-center">
                                    <Form.Control
                                      type="number"
                                      className="input-text-14 me-1"
                                      style={{ width: "65px" }}
                                      required
                                      value={initialProfiles.teamPlayer}
                                      onChange={(e) => {
                                        if (
                                          (Number(e.target.value) <= 100 &&
                                            Number(e.target.value >= 0)) ||
                                          e.target.value === ""
                                        ) {
                                          handleProfiles(
                                            "teamPlayer",
                                            e.target.value
                                          );
                                        }
                                      }}
                                    ></Form.Control>
                                    %
                                  </td>
                                </tr>
                                <tr>
                                  <td className="job_size">
                                    Logical Thinker (4)
                                  </td>
                                  <td className="d-flex justify-content-center align-items-center">
                                    <Form.Control
                                      type="number"
                                      className="input-text-14  me-1"
                                      style={{ width: "65px" }}
                                      required
                                      value={initialProfiles.logicalThinker}
                                      onChange={(e) => {
                                        if (
                                          (Number(e.target.value) <= 100 &&
                                            Number(e.target.value >= 0)) ||
                                          e.target.value === ""
                                        ) {
                                          handleProfiles(
                                            "logicalThinker",
                                            e.target.value
                                          );
                                        }
                                      }}
                                    ></Form.Control>
                                    %
                                  </td>
                                </tr>
                                <tr>
                                  <td className="job_size">Persuader (5)</td>
                                  <td className="d-flex justify-content-center align-items-center">
                                    <Form.Control
                                      type="number"
                                      className="input-text-14 me-1"
                                      style={{ width: "65px" }}
                                      required
                                      value={initialProfiles.persuader}
                                      onChange={(e) => {
                                        if (
                                          (Number(e.target.value) <= 100 &&
                                            Number(e.target.value >= 0)) ||
                                          e.target.value === ""
                                        ) {
                                          handleProfiles(
                                            "persuader",
                                            e.target.value
                                          );
                                        }
                                      }}
                                    ></Form.Control>
                                    %
                                  </td>
                                </tr>
                                <tr>
                                  <td className="job_size">Achiever (6)</td>
                                  <td className="d-flex justify-content-center align-items-center">
                                    <Form.Control
                                      type="number"
                                      className="input-text-14 me-1"
                                      style={{ width: "65px" }}
                                      required
                                      value={initialProfiles.achiever}
                                      onChange={(e) => {
                                        if (
                                          (Number(e.target.value) <= 100 &&
                                            Number(e.target.value >= 0)) ||
                                          e.target.value === ""
                                        ) {
                                          handleProfiles(
                                            "achiever",
                                            e.target.value
                                          );
                                        }
                                      }}
                                    ></Form.Control>
                                    %
                                  </td>
                                </tr>
                                <tr>
                                  <td className="job_size">
                                    Perfectionist (7)
                                  </td>
                                  <td className="d-flex justify-content-center align-items-center">
                                    <Form.Control
                                      type="number"
                                      className="input-text-14 me-1"
                                      style={{ width: "65px" }}
                                      required
                                      value={initialProfiles.perfectionist}
                                      onChange={(e) => {
                                        if (
                                          (Number(e.target.value) <= 100 &&
                                            Number(e.target.value >= 0)) ||
                                          e.target.value === ""
                                        ) {
                                          handleProfiles(
                                            "perfectionist",
                                            e.target.value
                                          );
                                        }
                                      }}
                                    ></Form.Control>
                                    %
                                  </td>
                                </tr>
                                <tr>
                                  <td className="job_size">Collaborator (8)</td>
                                  <td className="d-flex justify-content-center align-items-center">
                                    <Form.Control
                                      type="number"
                                      className="me-1"
                                      style={{ width: "65px" }}
                                      required
                                      value={initialProfiles.collaborator}
                                      onChange={(e) => {
                                        if (
                                          (Number(e.target.value) <= 100 &&
                                            Number(e.target.value >= 0)) ||
                                          e.target.value === ""
                                        ) {
                                          handleProfiles(
                                            "collaborator",
                                            e.target.value
                                          );
                                        }
                                      }}
                                    ></Form.Control>
                                    %
                                  </td>
                                </tr>

                                <tr>
                                  <td className="job_size">Accessor (9)</td>
                                  <td className="d-flex justify-content-center align-items-center">
                                    <Form.Control
                                      type="number"
                                      className="input-text-14 me-1"
                                      style={{ width: "65px" }}
                                      required
                                      value={initialProfiles.assessor}
                                      onChange={(e) => {
                                        if (
                                          (Number(e.target.value) <= 100 &&
                                            Number(e.target.value >= 0)) ||
                                          e.target.value === ""
                                        ) {
                                          handleProfiles(
                                            "assessor",
                                            e.target.value
                                          );
                                        }
                                      }}
                                    ></Form.Control>
                                    %
                                  </td>
                                </tr>
                                <tr>
                                  <td className="job_size">Implementor (10)</td>
                                  <td className="d-flex justify-content-center align-items-center">
                                    <Form.Control
                                      type="number"
                                      className="input-text-14 me-1"
                                      style={{ width: "65px" }}
                                      required
                                      value={initialProfiles.implementor}
                                      onChange={(e) => {
                                        if (
                                          (Number(e.target.value) <= 100 &&
                                            Number(e.target.value >= 0)) ||
                                          e.target.value === ""
                                        ) {
                                          handleProfiles(
                                            "implementor",
                                            e.target.value
                                          );
                                        }
                                      }}
                                    ></Form.Control>
                                    %
                                  </td>
                                </tr>
                                <tr>
                                  <td className="job_size">Motivator (11)</td>
                                  <td className="d-flex justify-content-center align-items-center">
                                    <Form.Control
                                      type="number"
                                      className="input-text-14 me-1"
                                      style={{ width: "65px" }}
                                      required
                                      value={initialProfiles.motivator}
                                      onChange={(e) => {
                                        if (
                                          (Number(e.target.value) <= 100 &&
                                            Number(e.target.value >= 0)) ||
                                          e.target.value === ""
                                        ) {
                                          handleProfiles(
                                            "motivator",
                                            e.target.value
                                          );
                                        }
                                      }}
                                    ></Form.Control>
                                    %
                                  </td>
                                </tr>
                                <tr>
                                  <td className="job_size">eader (12)</td>
                                  <td className="d-flex justify-content-center align-items-center">
                                    <Form.Control
                                      type="number"
                                      className="input-text-14 me-1"
                                      style={{ width: "65px" }}
                                      required
                                      value={initialProfiles.leader}
                                      onChange={(e) => {
                                        if (
                                          (Number(e.target.value) <= 100 &&
                                            Number(e.target.value >= 0)) ||
                                          e.target.value === ""
                                        ) {
                                          handleProfiles(
                                            "leader",
                                            e.target.value
                                          );
                                        }
                                      }}
                                    ></Form.Control>
                                    %
                                  </td>
                                </tr>
                                <tr>
                                  <td className="job_size">
                                    Administrator (13)
                                  </td>
                                  <td className="d-flex justify-content-center align-items-center">
                                    <Form.Control
                                      type="number"
                                      className="input-text-14 me-1"
                                      style={{ width: "65px" }}
                                      required
                                      value={initialProfiles.administrator}
                                      onChange={(e) => {
                                        if (
                                          (Number(e.target.value) <= 100 &&
                                            Number(e.target.value >= 0)) ||
                                          e.target.value === ""
                                        ) {
                                          handleProfiles(
                                            "administrator",
                                            e.target.value
                                          );
                                        }
                                      }}
                                    ></Form.Control>
                                    %
                                  </td>
                                </tr>
                                <tr>
                                  <td className="job_size">Mediator (14)</td>
                                  <td className="d-flex justify-content-center align-items-center">
                                    <Form.Control
                                      type="number"
                                      className="input-text-14 me-1"
                                      style={{ width: "65px" }}
                                      required
                                      value={initialProfiles.mediator}
                                      onChange={(e) => {
                                        if (
                                          (Number(e.target.value) <= 100 &&
                                            Number(e.target.value >= 0)) ||
                                          e.target.value === ""
                                        ) {
                                          handleProfiles(
                                            "mediator",
                                            e.target.value
                                          );
                                        }
                                      }}
                                    ></Form.Control>
                                    %
                                  </td>
                                </tr>
                                <tr>
                                  <td className="job_size">All Rounder (15)</td>
                                  <td className="d-flex justify-content-center align-items-center">
                                    <Form.Control
                                      type="number"
                                      className="input-text-14 me-1"
                                      style={{ width: "65px" }}
                                      required
                                      value={initialProfiles.allRounder}
                                      onChange={(e) => {
                                        if (
                                          (Number(e.target.value) <= 100 &&
                                            Number(e.target.value >= 0)) ||
                                          e.target.value === ""
                                        ) {
                                          handleProfiles(
                                            "allRounder",
                                            e.target.value
                                          );
                                        }
                                      }}
                                    ></Form.Control>
                                    %
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </>
                        }
                        {/* <Form.Group controlId="Primary match %" className="mb-3">
                  <Form.Label>Primary match %</Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Primary match %"
                    value={details?.primaryMatch}
                    onChange={(e) =>
                      (e.target.value === "" ||
                        (Number(e.target.value) <= 100 &&
                          Number(e.target.value) > 0)) &&
                      handleChage("primaryMatch", e.target.value)
                    }
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    Please Enter Primary Match!
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group controlId="Secondary match %" className="mb-3">
                  <Form.Label>Secondary match %</Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Secondary match %"
                    required
                    value={details?.secoundryMatch}
                    onChange={(e) =>
                      (e.target.value === "" ||
                        (Number(e.target.value) <= 100 &&
                          Number(e.target.value) > 0)) &&
                      handleChage("secoundryMatch", e.target.value)
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    Please Enter Secoundry Match!
                  </Form.Control.Feedback>
                </Form.Group> */}
                        {/* <Form.Group className="mb-3">
                          <Form.Label className="job_size">
                            Email Id to be used to send communications to
                            candidate
                          </Form.Label>
                          <Form.Select
                            className="input-text-14 "
                            value={details.from}
                            onChange={(e) =>
                              handleChage("from", e.target.value)
                            }
                          >
                            <option value="" selected disabled>
                              Select Email
                            </option>
                            {emailList
                              .filter((x) => x.verified === true)
                              .map((email, index) => (
                                <option value={email.from_Email} key={index}>
                                  {email.from_Email}
                                </option>
                              ))}
                          </Form.Select>
                      
                        </Form.Group> */}
                        {/* <div>
                          <Form.Group
                            controlId="Primary match %"
                            className="mb-3 position-relative mt-3"
                          >
                            <div className="row justify-content-between mt-3">
                              <Form.Label className="job_size">
                                Job Access Group
                              </Form.Label>
                              <div className="col">
                                <input
                                  className="form-control input-text-14"
                                  type="email"
                                  isInvalid={valiteded && showEmails.length}
                                  placeholder="Job Access Group"
                                  value={enterEmail}
                                  onChange={(e) =>
                                    setEnterEmail(e.target.value)
                                  }
                                />
                              
                              </div>
                              <div className="col-2">
                                <button
                                  className="btnVldt"
                                  style={{ fontSize: "12px" }}
                                  onClick={handleAddEmail}
                                >
                                  Add
                                </button>
                              </div>
                            </div>

                            {
                              <div className="col-5 position-absolute start-0 mt-3">
                                {showEmails.map((email, index) => (
                                  <span
                                    className="addbackgroundcolor px-2 py-1 rounded-5 me-3 text-nowrap"
                                    key={index}
                                  >
                                    {email?.email}
                                    <button
                                      type="button"
                                      className="btn-close"
                                      style={{
                                        width: "5px",
                                        height: "7px",
                                        marginLeft: "4px",
                                        opacity: "0.8",
                                        marginBottom: "-5px",
                                      }}
                                      onClick={() => removeEmail(index)}
                                    ></button>
                                    
                                  </span>
                                ))}
                              </div>
                            }
                          </Form.Group>
                        </div> */}
                      </>
                    )}
                  </div>
                  <div className={`d-flex justify-content-end`}>
                    <button
                      className={`btnVldt ${isEdit ? "mt-55" : ""}`}
                      style={{ fontSize: "12px" }}
                      type="submit"
                    >
                      {isEdit ? "Update" : "Add"} Group
                    </button>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
      )}
      <Modal
        show={isAddCompany}
        centered
        onHide={() => setIsAddCompany(false)}
        size="lg"
      >
        <Modal.Header closeButton className="custom-close-btn">
          <h6 className="mb-0 mt-1">Add Company Details</h6>
        </Modal.Header>
        <Modal.Body>
          <div>
            <AddCompany
              isHandle={true}
              handleSubmitClose={() => handleAddCompamy()}
              id={details?.companyId}
            />
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default GroupList;
